import { render, staticRenderFns } from "./Subdomains.vue?vue&type=template&id=15993615&scoped=true&"
import script from "./Subdomains.vue?vue&type=script&lang=js&"
export * from "./Subdomains.vue?vue&type=script&lang=js&"
import style0 from "./Subdomains.vue?vue&type=style&index=0&id=15993615&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15993615",
  null
  
)

export default component.exports